<header class="anameta-header">

    <div class="header-inner">

        <!-- =====================================================
             BRAND
             ===================================================== -->

        <a class="brand" routerLink="/" aria-label="ANAMETA">
            <img src="/logo/logo0.png" alt="ANAMETA" />
        </a>


        <!-- =====================================================
             MAIN NAVIGATION
             ===================================================== -->

        <nav class="main-navigation">

            <a
                class="main-nav-item"
                routerLink="/"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">

                <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M3 11.5 12 4l9 7.5"></path>
                    <path d="M5.5 10.5V20h13v-9.5"></path>
                    <path d="M9.5 20v-6h5v6"></path>
                </svg>

                <span>Anasayfa</span>

            </a>


            <a
                class="main-nav-item"
                routerLink="/market"
                routerLinkActive="active">

                <svg viewBox="0 0 24 24" aria-hidden="true">
                    <circle cx="9" cy="20" r="1.3"></circle>
                    <circle cx="18" cy="20" r="1.3"></circle>
                    <path d="M2.5 4h2l2.2 10.4a2 2 0 0 0 2 1.6h8.6a2 2 0 0 0 2-1.6L21 8H6"></path>
                </svg>

                <span>Market</span>

            </a>

        </nav>


        <!-- =====================================================
             RIGHT ACTIONS
             ===================================================== -->

        <div class="header-actions">


            <!-- =================================================
                 CURRENCY
                 ================================================= -->

            <div
                class="header-dropdown-wrapper"
                (click)="$event.stopPropagation()">

                <button
                    type="button"
                    class="header-dropdown-button"
                    [class.open]="currencyDropdownOpen"
                    aria-haspopup="true"
                    [attr.aria-expanded]="currencyDropdownOpen"
                    (click)="ToggleCurrencyDropdown($event)">

                    <span class="currency-icon">
                        {{ selectedCurrency.symbol }}
                    </span>

                    <span class="dropdown-label">
                        {{ selectedCurrency.code }}
                    </span>

                    <svg class="chevron" viewBox="0 0 24 24" aria-hidden="true">
                        <path d="m7 9 5 5 5-5"></path>
                    </svg>

                </button>


                <div
                    *ngIf="currencyDropdownOpen"
                    class="header-dropdown-panel currency-menu">

                    <button
                        type="button"
                        class="header-dropdown-option"
                        *ngFor="let currency of currencies"
                        [class.selected]="currency.code === selectedCurrency.code"
                        (click)="SelectCurrency(currency, $event)">

                        <span class="flag">
                            {{ currency.flag }}
                        </span>

                        <span class="option-code">
                            {{ currency.code }}
                        </span>

                        <span class="option-symbol">
                            {{ currency.symbol }}
                        </span>

                    </button>

                </div>

            </div>


            <!-- =================================================
                 LANGUAGE
                 ================================================= -->

            <div
                class="header-dropdown-wrapper"
                (click)="$event.stopPropagation()">

                <button
                    type="button"
                    class="header-dropdown-button language-button"
                    [class.open]="languageDropdownOpen"
                    aria-haspopup="true"
                    [attr.aria-expanded]="languageDropdownOpen"
                    (click)="ToggleLanguageDropdown($event)">

                    <span class="flag selected-flag">
                        {{ selectedLanguage.flag }}
                    </span>

                    <span class="dropdown-label">
                        {{ selectedLanguage.code }}
                    </span>

                    <svg class="chevron" viewBox="0 0 24 24" aria-hidden="true">
                        <path d="m7 9 5 5 5-5"></path>
                    </svg>

                </button>


                <div
                    *ngIf="languageDropdownOpen"
                    class="header-dropdown-panel language-menu">

                    <button
                        type="button"
                        class="header-dropdown-option"
                        *ngFor="let language of languages"
                        [class.selected]="language.code === selectedLanguage.code"
                        (click)="SelectLanguage(language, $event)">

                        <span class="flag">
                            {{ language.flag }}
                        </span>

                        <span class="language-code">
                            {{ language.code }}
                        </span>

                        <span class="language-name">
                            {{ language.name }}
                        </span>

                    </button>

                </div>

            </div>


            <!-- =================================================
                 LOGIN
                 ================================================= -->

            <button
                type="button"
                class="login-button"
                (click)="Login()">

                <svg viewBox="0 0 24 24" aria-hidden="true">
                    <circle cx="12" cy="8" r="4"></circle>
                    <path d="M4.5 21c.5-4.3 3.2-6.5 7.5-6.5s7 2.2 7.5 6.5"></path>
                </svg>

                <span>Giriş Yap</span>

            </button>

        </div>

    </div>

</header>